import type { FunctionComponent } from 'react';

import ApplyButton from './ApplyButton';
import BorrowAmount from './BorrowAmount';
import ChooseAPR from './ChooseAPR';
import ChooseTerm from './ChooseTerm';
import FinanceInfo from './FinanceInfo';
import PreApprovalMessage from './PreApprovalMessage';
import SelectNewRate from './SelectNewRate';
import SelectedRatePreApprovalMessage from './SelectedRatePreApprovalMessage';
import useRates from './useRates';

interface RatesProps {
  isLoading: boolean;
  isSubmitting: boolean;
  selectNewRate: boolean;
}

const Rates: FunctionComponent<RatesProps> = function ({
  isLoading,
  isSubmitting,
  selectNewRate,
}) {
  const {
    allRates: rates,
    interest,
    min,
    max,
    depositLimits,
    duration,
    selectedRate,
    error,
    hasCredit,
    isSecondLine,
  } = useRates();

  return (
    <>
      {hasCredit ? (
        <SelectNewRate secondLine={isSecondLine} />
      ) : (
        <PreApprovalMessage rates={rates} />
      )}
      <ChooseAPR rates={rates} isLoading={isLoading} />
      {interest && <ChooseTerm rates={rates[interest]} isLoading={isLoading} />}
      {duration && (
        <BorrowAmount
          isLoading={isLoading}
          depositLimits={depositLimits}
          min={min}
          max={max}
          creditLine={selectedRate?.creditLine || 0}
        />
      )}
      {duration && (
        <FinanceInfo isLoading={isLoading} selectedRate={selectedRate} />
      )}
      {selectedRate && (
        <SelectedRatePreApprovalMessage selectedRate={selectedRate} />
      )}
      {duration && (
        <ApplyButton
          selectNewRate={selectNewRate}
          interest={interest}
          isSubmitting={isSubmitting}
          isLoading={isLoading}
          disabled={!!error}
        />
      )}
    </>
  );
};

export default Rates;
